// src/services/reglasNivelUsuariosService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'reglas-nivel/';

export interface ReglaNivelUsuario {
    id: number;
    nombre: string;
    nivel_destino: number;          
    nivel_destino_nombre: string;   
    min_citas: number | null;
    periodo_dias: number | null;
    min_duracion_total_dias: number | null;
    min_monto_pagado: string | null; 
    prioridad: number;
    activo: boolean;
    fecha_creacion: string;           
}

export type ReglaNivelUsuarioCreate = {
    nombre: string;
    nivel_destino: number;
    min_citas?: number | null;
    periodo_dias?: number | null;
    min_duracion_total_dias?: number | null;
    min_monto_pagado?: string | null;
    prioridad?: number;   // default 0
    activo?: boolean;     // default true
};

export type ReglaNivelUsuarioUpdate = {
    nombre: string;
    nivel_destino: number;
    min_citas: number | null;
    periodo_dias: number | null;
    min_duracion_total_dias: number | null;
    min_monto_pagado: string | null;
    prioridad: number;
    activo: boolean;
};

export const fetchReglasNivel = async (): Promise<ReglaNivelUsuario[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const getReglaNivel = async (id: number): Promise<ReglaNivelUsuario> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

export const createReglaNivel = async (data: ReglaNivelUsuarioCreate): Promise<ReglaNivelUsuario> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

export const updateReglaNivel = async (
    id: number,
    data: ReglaNivelUsuarioUpdate
): Promise<ReglaNivelUsuario> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Actualización parcial (PATCH) - útil para cambios rápidos
export const patchReglaNivel = async (
    id: number,
    data: Partial<ReglaNivelUsuarioUpdate>
): Promise<ReglaNivelUsuario> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar una regla
export const deleteReglaNivel = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};

// Acción personalizada: recalcular nivel de un usuario
export const recalcularNivelUsuario = async (userId: number): Promise<{ mensaje: string; nuevo_nivel: string | null }> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(`${API_URL}recalcular_usuario/`, { user_id: userId });
        return response.data;
    });
};